<template>
  <v-layout wrap>
    <v-flex xs12>
      <reversible-text-field 
        :text="bookData.title"
        :label="'Título do livro'"
        :textClass="'headline'"
        :class="'mb-5'"
        @didTapSave="didTapSaveTitle"
      />
    </v-flex>
    <v-flex xs12>
      <reversible-text-field multiline
        :evaluateLength="false"
        :text="bookData.description"
        :label="'Descrição breve'"
        :textClass="'body'"
        :class="'mb-5'"
        @didTapSave="didTapSaveDescription"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { rdb } from "@/firebase/config";
import ReversibleTextField from "@/components/ReversibleTextField";

export default {
  components: {
    ReversibleTextField
  },
  data: () => ({
    bookData: {}
  }),
  firebase: {
    bookData: rdb.ref("bookData")
  },
  methods: {
    didTapSaveTitle(value) {
      this.$firebaseRefs.bookData.update({ title: value });
    },
    didTapSaveDescription(value) {
      this.$firebaseRefs.bookData.update({ description: value });
    }
  }
};
</script>
